import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'recruiterMessageGroupby'
})
export class RecruiterMessageGroupbyPipe implements PipeTransform {
  constructor(public datePipe: DatePipe) { }

  transform(value: Array<any>, property: string, clear_message_time: string): Array<any> {
    //console.log('clear_message_time',clear_message_time);
    if (!value) return [];
    var messages: any[] = [];
    value.forEach((x) => {
      //console.log('x++++=====>',x);
      if(clear_message_time < x.firebase_message_time){
        var currentDate = new Date(this.datePipe.transform(new Date(), "MM/dd/yyyy") || "");
        var messageDate = new Date(this.datePipe.transform(x[property], "MM/dd/yyyy") || "");
        const diffTime = Math.abs((messageDate as any) - (currentDate as any));
        const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        var header = days == 0 ? 'Today' : days == 1 ? 'Yesterday' : this.datePipe.transform(messageDate, "MM/dd/yyyy");
        var hasData = messages.find((x) => x['day'] == header);
        if (!hasData) {
          messages.push({ 'day': header, 'messages': [] });
          hasData = messages.find((x) => x['day'] == header);
        }
      hasData['messages'].push(x);
      }
    })
    return messages;
  }
}
